export const getYear = state => state.reportVehicleProfits.getIn(['list', 'year'])

export const getData = state => state.reportVehicleProfits.getIn(['list', 'data'])
export const getFetching = state => state.reportVehicleProfits.getIn(['list', 'fetching'])
export const getError = state => state.reportVehicleProfits.getIn(['list', 'error'])

export const getDetailsData = state => state.reportVehicleProfits.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportVehicleProfits.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportVehicleProfits.getIn(['details', 'error'])
